export function makeInitialDataItems(data) {
    const initialData = data?.garrison ?? {};

    return [
        {
            label: "D/H inicial",
            value: initialData?.garrison_start ?? "",
        },
        {
            label: "D/H final",
            value: initialData?.garrison_end ?? "",
        },
        {
            label: "Status",
            value: initialData?.garrison_status ? "EM ANDAMENTO" : "ENCERRADO" ?? "",
        },
        {
            label: "Responsável",
            value: initialData?.responsible ?? "",
        },
        {
            label: "Equipe",
            value: initialData?.garrison_team ?? "",
        },
        {
            label: "Função destinada",
            value: initialData?.garrison_intendedfunction ?? "",
        },
        {
            label: "Local pré-cadastrado",
            value: initialData?.garrison_place ?? "",
        },
        {
            label: "Setor",
            value: initialData?.sectors ?? "",
        },
    ];
}